/** @jsx dom */
import dom from 'magic-virtual-element';
import {Image} from '~/media';
import {utils as cmsUtils} from '@viskan/cms-components';

const defaultProps = {
	align: 'Blurb6-flex--textCenter',
	horizontalPos: 'Blurb6-flex--horizontalCenter',
	verticalPos: 'Blurb6-flex--verticalCenter'
};

const parseNumber = num => parseInt(num, 10) || 0;

const getContent = (props, contentStyles) => {
	const {imgSrc, imgUrl} = props;

	return (
		<div class={['Blurb6-flexContainer', props.verticalPos, props.horizontalPos, props.showContentOnHover && 'Blurb6-flexContainer-animation']}>
			<a href={imgUrl}>
				<div class={['Blurb6-content Blurb6-flex', props.styleClasses.Content, props.align]} style={contentStyles} data-style-attr='Content'>
					{imgSrc && <Image source={imgSrc} data-style-attr='Image'/>}
					{props.title && <div class={['Blurb6-title', props.styleClasses.Title]} data-style-attr='Title'>{props.title}</div>}
					{props.text && <p class={['Blurb6-text', props.styleClasses.Text]} data-style-attr='Text'>{props.text}</p>}
				</div>
				<div>
					{props.showContentOnHover && <div class='Blurb6-hover'>{props.buttonTextTwo}</div>}
				</div>
			</a>
			<div class='Blurb6-parent'>
				{props.showButtonOne && <a href={props.navUrlOne} class='Blurb6-buttonOne' data-style-attr='ButtonOne'>{props.buttonTextOne}</a>}
			</div>
		</div>
	);
};

const render = ({props}) => {
	const contentStyles = {
		'margin-left': parseNumber(props.marginLeft),
		'margin-right': parseNumber(props.marginRight),
		'margin-top': parseNumber(props.marginTop),
		'margin-bottom': parseNumber(props.marginBottom)
	};

	const content = getContent(props, contentStyles);

	return cmsUtils.createCmsComponent((
		<div data-style-attr='Blurb'>
			{(content)}
		</div>
	), props);
};

export default {render, defaultProps};
